<template>
  <a-card :bordered="false">
    <div class="s_c333 mb10" v-if="detail.total">活动码总数:<span>{{detail.total}}</span>,中奖码总数:<span>{{detail.award_num}}</span>,剩余<span>{{detail.not_num}}</span>为无奖项(不中奖)</div>
    <a-table :pagination='false' bordered :columns='columns' rowKey="award_id" :data-source='awardList' :scroll="{ x: true}">
    </a-table>
    <div class="s_c333 mb10 m-t-10" v-if="detail.scan_num">当前活动已扫码数量<span>{{detail.scan_num}}</span>(已中奖数量:<span>{{detail.scan_sure_num}}</span>,未中奖数量:<span>{{detail.scan_not_num}}</span>)</div>
  </a-card>
</template>

<script>
let columns = [
  {
    title: "奖项名称",
    dataIndex: "award_name",
    key: "award_name",
  },
  {
    title: "中奖码数量",
    dataIndex: "award_num",
    key: "award_num",
  },
  {
    title: "中奖率",
    key: "percent",
    dataIndex: "percent",
  },
  {
    title: "奖项内容",
    dataIndex: "award_content",
    key: "award_content",
  },
  {
    title: "已中奖数量",
    dataIndex: "award_sure_num",
    key: "award_sure_num",
  },
];
export default {
  name:'award',
  props:{
    awardList:Array,
    detail:Object
  },
    setup(){
      return{
        columns
      }
    }
}
</script>